import Dropdowns from './svelte/dropdown-navigation.svelte';

const init = (target: HTMLElement) => new Dropdowns({
  target,
});

export default init;
